import { Component } from '@angular/core';
import { NavController, LoadingController, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Broadcaster } from '../../app/broadcaster';
//import { Http, Headers, RequestOptions } from '@angular/http';
import { Localization } from '../../app/app.localization';
import { ApiService } from '../../app/services/api.service';
import { Config } from  '../../app/app.config';
import { CustomModalComponent } from '../../components/custom-modal/custom-modal';
import { OkageGoGoogleAnalyticsProvider } from '../../providers/okage-go-google-analytics/okage-go-google-analytics';

@Component({
  selector: 'page-order-stop',
  templateUrl: 'order-stop.html',
  providers: [ApiService]
})

export class OrderStopPage {

  message: any;

  constructor(public navCtrl: NavController,
    private storage: Storage,
    private _loc: Localization,
    private broadcaster: Broadcaster,
    private _apiService: ApiService,
    private loadingCtrl: LoadingController,
    private _ga: OkageGoGoogleAnalyticsProvider,
    private modalCtrl: ModalController
    /*public http: Http*/) {
    
    this.message = "";
  }

  ionViewWillEnter(){
    this._ga.orderStopPageView();
    switch (parseInt(localStorage.getItem("open_status"))) {
      case 0 : // 中止
        this.message = localStorage.getItem("close_message");
        break;
      
      case 2 : // 一時停止
        this.message = localStorage.getItem("pause_message");
        break;
      
      case 4 : // 営業時間外
        this.message = localStorage.getItem("closed_time_message");
        break;
      
      case 5 : // 予約時間外
      this.message = localStorage.getItem("reserved_stop_message");
      break;

      default : // その他
        this.message = localStorage.getItem("close_message");
        break;
    }
    if(!this.message){
        this.message = this._loc.t('現在利用できません。');
    }

    let modal = this.modalCtrl.create(CustomModalComponent, { message: this.message, showBackdrop: false, enableBackdropDismiss: false });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-stop/order-stop.ts